module.exports = __webpack_public_path__ + "static/media/irish-manu.d282e3fd.png";